import React, { Component } from 'react';
import { Input, Button, message } from 'antd';
import { isValidName } from '../../common/utils';
import { checkWalletName } from '../../common/fetch';

class NamingWallet extends Component {
	state = {
		wallet: ''
	};

	checkDuplication = async (wallet) => {
		const { onSubmit } = this.props;
		try {
			await checkWalletName(wallet);
			onSubmit(wallet);
		} catch (error) {
			message.warn(error.data.message);
		}
	};

	render() {
		const { wallet } = this.state;
		const isDisabled = isValidName(wallet);
		return (
			<div>
				<div style={{ paddingBottom: '24px' }}>
					<Input
						name="wallet"
						value={wallet}
						onChange={(e) => {
							this.setState({ wallet: e.target.value });
						}}
					/>
				</div>
				<Button
					block
					type="primary"
					disabled={!isDisabled}
					onClick={() => {
						this.checkDuplication(wallet);
					}}
				>
					Next
				</Button>
			</div>
		);
	}
}

export default NamingWallet;
